import { render } from "./FormTitle.vue?vue&type=template&id=1cb73f3e&scoped=true&ts=true"
import script from "./FormTitle.vue?vue&type=script&lang=ts"
export * from "./FormTitle.vue?vue&type=script&lang=ts"

import "./FormTitle.vue?vue&type=style&index=0&id=1cb73f3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb73f3e"]])

export default __exports__